import React, { memo } from 'react';
import { Product } from '@types';
import { ViewerThumb } from '../viewer-thumb';

import styles from '../viewer-window.module.scss';

interface ProductViewerProps {
    product: Product;
}

export const ProductViewer = memo<ProductViewerProps>(
    ({ product }) => {
        return (
            <div className={styles.box}>
                <div className={styles.inner}>
                    <ViewerThumb smallThumb={product?.model_thumbnail} show expanded={false} />
                </div>
            </div>
        );
    },
    (prev, next) => {
        return prev.product.id === next.product.id;
    },
);
